import { render } from "./ProfileList.vue?vue&type=template&id=32b92d80&scoped=true"
import script from "./ProfileList.vue?vue&type=script&lang=js"
export * from "./ProfileList.vue?vue&type=script&lang=js"

import "./ProfileList.vue?vue&type=style&index=0&id=32b92d80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b92d80"]])

export default __exports__